import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import * as pbi from "powerbi-client";
import { useEffect, useState } from 'react';
import { ConfigBI } from "../../configs/ConfigBI";
import "./powerBi.css";


const pbiUrl = 'https://app.powerbi.com/reportEmbed?';
const pbiConfigParam = '&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwiZGlzYWJsZUFuZ3VsYXJKU0Jvb3RzdHJhcFJlcG9ydEVtYmVkIjp0cnVlfX0%3d';

const PBIReportFilter = (props) => {
    const [renderFlag, setrenderFlag] = useState(false);
    const [valueFilter, setValueFilter] = useState([]);

    const models = pbi.models;
    const customCss = props?.customCss ?? 'default-pbicss';

    const pbiConfig = {
        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
        tokenType: models.TokenType.Aad,
        accessToken: props.BiToken,
        embedUrl: `${pbiUrl}reportId=${props.reportId}${pbiConfigParam}`,

        permissions: models.Permissions.Read.All,
        id: props.reportId,

        settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth
            },
            panes: {
                filters: {
                    expanded: false,
                    visible: true
                },
                pageNavigation: {
                    visible: false
                },
            },
        },
        filters: valueFilter
    };

    useEffect(() => {
        try {
            if (props?.filterValues && props?.filterValues.length > 0) {
                const filtersdata = props.filterValues.map((item) => ({
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                      table: item?.tableName ?? '', // "Product Hierarchy",
                   //   table:  "Product Hierarchy",
                     // table: item?.tableName.includes(' ') ? `'${item?.tableName}'` : item?.tableName,

                        column:  item?.columnName ?? '' //"ISBN"
                    },
                    operator: item.values && item.values.length > 0 ? "In" : "All",
                    values: item.values,
                    filterType: models.FilterType.Basic,
                    requireSingleSelection: true
                }));
                setValueFilter(filtersdata ?? []);
                setrenderFlag(prev => !prev);
             //   console.debug(props.name,filtersdata);
            } else {
                setValueFilter([]);
            }
        }
        catch ({ name, message }) {
            console.warn('Failed to get filter values.');
        }
    }, [props.filterValues])

/*    useEffect(() => {
        try {
            if (props?.filterValue) {
                setValueFilter([props?.filterValue]);
                setrenderFlag(prev => !prev);
            } else {
                setValueFilter([]);
            }
        }
        catch ({ name, message }) {
            console.warn('Failed to get filter value.');
        }
    }, [props.filterValue])*/

    const reportLoaded = async (event) => {
        //try {
        //    console.info('reportLoaded', props);
        //    const embedContainer = document.getElementsByClassName("invPbiReport")[0];
        //    const report = await powerbi.get(embedContainer);
        //    const pages = await report.getPages();           
        //    if (pages?.length == 0) { console.warn(`There are no pages on the report`); return; }
        //    if (pages.length < 2) {
        //        return;
        //    }
        //    pages.forEach(page => {                
        //        page.getFilters().then(filters => {
        //            try {
        //                console.info('reportLoaded.filters before', page.displayName, filters);
        //                if (!filters) { filters = []; }
        //                filters.push(...valueFilter);
        //                page.setFilters(filters);
        //                console.info('reportLoaded.filters after', page.displayName, filters);
        //            }
        //            catch ({name, message}) {
        //                console.info("Set Filter Error", name, message);
        //            }
        //        });
        //    });
        //} catch ({ name, message }) {
        //    console.info("Filter Error", name, message);
        //}
    }

    const pageChange = async(event) => {
        console.debug('pageChange', valueFilter, props, event);
       // console.debug(`${props?.name} pageChanged`, event);
       // setrenderFlag(prev => !prev);
        // console.log(`${filterValues} pageChanged`, event);
        //const embedContainer = document.getElementsByClassName("invPbiReport")[0];
        //const report = await powerbi.get(embedContainer);
        //const pages = await report.getPages();
        ////pages[0].report.bookmarksManager.config.filters = valueFilter;
        //console.debug("filters",props?.name,pages);
        //console.debug(props?.name, pages[0].report.bookmarksManager;

        //const currentPage = pages.find(p => p.isActive);
        //await pages.forEach(i => { console.debug("Current filters:", i.getFilters()) });
        //const filters = await currentPage.getFilters();

        //console.debug("Current filters:", filters);

        // You can apply these filters to the new page or modify as needed
        // Example: Reapply the filters after the page change
        //await currentPage.setFilters(filters);
        //console.log("Filters reapplied to the new page");

    }
    return (<>
        {props.BiToken == '' ? <>Loading...</> :
            <PowerBIEmbed
                embedConfig={pbiConfig}
                eventHandlers={
                    new Map([
                        ['loaded', (event) =>reportLoaded(event)],
                        ['rendered', (event) => console.debug(`${props?.name} rendered`, event)],
                        ['error', (event) => console.debug(`${props?.name} error`, event)],
                        ['visualClicked', (event) => console.debug(`${props?.name} visualClicked`, event)],
                        ['pageChanged', (event) => pageChange(event)],
                        ['dataSelected', (event) => console.debug(`${props?.name} Report dataSelected`, event?.detail?.dataPoints)],
                    ])}
                cssClassName={`Embed-container invPbiReport ${customCss}`}
               // cssClassName={"Embed-container dboard invHubDashboard"}
                key={renderFlag ? "key1" : "key2"}
            />}

    </>

    );
};
export default PBIReportFilter;
